/* eslint-disable react/jsx-indent */
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'rsuite';
import { selectorDataPointsExhibitionType, SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN } from '../../../../../reducers/gerenciadorPrecos';
import { RowData } from '../../../../../reducers/gerenciadorPrecos/datapoints';
import { RESET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS } from '../../../../../reducers/getStoreFamilyClusterModal/datapoints';
import { CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS } from '../../../../../reducers/getStoreFamilyClusterModal/editedStoreFamilyClusterDatapoints';
import { RESET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION } from '../../../../../reducers/getStoreFamilyClusterModal/pagination';
import { RESET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT } from '../../../../../reducers/getStoreFamilyClusterModal/sort';
import { RESET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS } from '../../../../../reducers/getStoreFamilyClusterModal/totalElements';
import styles from './GetStoreFamilyClusterListModal.module.scss';
import { GetStoreFamilyClusterTable } from './components/GetStoreFamilyClusterTable';

type GetClusterStoreModalProps = {
  rowData: RowData;
  show: boolean;
  onHide: () => void;
};

export const GetStoreFamilyClusterModal = ({ rowData, show, onHide }: GetClusterStoreModalProps) => {
  const { clusterId, objectiveMargin, clusterName, productId, description, productFamilyId, clusterItemsCount, storeId } = rowData;

  const dispatch = useDispatch();

  const closeGetClusterStoreModal = () => {
    onHide();
    dispatch(SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN(false));
    dispatch(CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS());
    dispatch(RESET_GET_STORE_FAMILY_CLUSTER_MODAL_DATAPOINTS());
    dispatch(RESET_GET_STORE_FAMILY_CLUSTER_MODAL_PAGINATION());
    dispatch(RESET_GET_STORE_FAMILY_CLUSTER_MODAL_SORT());
    dispatch(RESET_GET_STORE_FAMILY_CLUSTER_MODAL_TOTAL_ELEMENTS());
  };

  const datapointExhibitionType = useSelector(selectorDataPointsExhibitionType);

  return (
    <Modal show={show} onHide={closeGetClusterStoreModal} className={styles['store-family-cluster-modal']}>
      <Modal.Header>
        <Modal.Title className={styles['modal-title']}>Família de produto</Modal.Title>
        <div className={styles['header-container']}>
          <div className={styles['header-container__row']}>
            <div className={styles['header-container__content']}>
              <p>FAMÍLIA DE PROUTO</p>
              <span>{productFamilyId}</span>
            </div>

            <div className={styles['header-container__content']}>
              <p>TOTAL DE PRODUTOS</p>
              <span>{rowData?.itemsCountFamily || '--'}</span>
            </div>

            <div className={styles['header-container__content']}>
              <p>PRODUTO PAI</p>
              <span>
                {productId} - <span className={styles['info']}>{description}</span>
              </span>
            </div>
          </div>
          <div className={styles['header-container__row']}>
            <div className={styles['header-container__content']}>
              <p>CLUSTER</p>
              <span>{clusterName}</span>
            </div>

            <div className={styles['header-container__content']}>
              <p>TOTAL DE LOJAS</p>
              <span>{clusterItemsCount}</span>
            </div>

            <div className={styles['header-container__content']}>
              <p>MARGEM OBJETIVA</p>
              <span>{objectiveMargin?.toFixed(1)}%</span>
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GetStoreFamilyClusterTable
          onHide={onHide}
          clusterId={clusterId as string}
          productId={productId as string}
          storeId={storeId as string}
          productFamilyId={productFamilyId as string}
          datapointExhibitionType={datapointExhibitionType}
        />
      </Modal.Body>
    </Modal>
  );
};
